// 主題偏好(spec 16 §6.1「強制支援深色模式…預設跟隨系統」)。
// 三態:system(跟隨 OS,預設)/ light / dark。
//  - system → 移除 html[data-theme],交給 tokens.css 的 @media prefers-color-scheme
//  - light/dark → 設 html[data-theme] 覆寫系統
// 持久化 localStorage('ls.theme'),與 i18n('ls.lang')同一套模式(see i18n/index.ts)。
export const THEME_PREFS = [
  { value: 'system', labelKey: 'account.themeSystem' },
  { value: 'light', labelKey: 'account.themeLight' },
  { value: 'dark', labelKey: 'account.themeDark' },
] as const;

export type ThemePref = (typeof THEME_PREFS)[number]['value'];

export const THEME_STORAGE_KEY = 'ls.theme';
export const DEFAULT_THEME: ThemePref = 'system';

function isPref(v: string | null | undefined): v is ThemePref {
  return v === 'system' || v === 'light' || v === 'dark';
}

/** 初始主題偏好:localStorage(使用者選定)→ 預設跟隨系統。 */
export function detectInitialTheme(): ThemePref {
  try {
    const saved = globalThis.localStorage?.getItem(THEME_STORAGE_KEY);
    if (isPref(saved)) return saved;
  } catch {
    /* SSR / 隱私模式 */
  }
  return DEFAULT_THEME;
}

/** 套用偏好到 <html data-theme>(不持久化)。boot 與切換共用。 */
export function applyTheme(pref: ThemePref): void {
  if (typeof document === 'undefined') return;
  const el = document.documentElement;
  if (pref === 'system') el.removeAttribute('data-theme');
  else el.setAttribute('data-theme', pref);
}

/** 切換主題並持久化(ThemeSwitcher 用)。 */
export function setTheme(pref: ThemePref): void {
  applyTheme(pref);
  try {
    globalThis.localStorage?.setItem(THEME_STORAGE_KEY, pref);
  } catch {
    /* SSR / 隱私模式 → 退化為本 session 記憶 */
  }
}
